import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogService } from '../../src/app/modules/domain/services/logging/log.service';
import { BenomadLayerComponent } from './components/layers/benomad-layer.component';
import { DeviceLayerComponent } from './components/layers/device-layer.component';
import { DrawInteractionComponent } from './components/draw.component';
import { MapComponent } from './components/map.component';
import { SelectInteractionComponent } from './components/select.component';
import { StreetLayerComponent } from './components/layers/street-layer.component';
import { InteractionService } from './services/interaction.service';
import { AddressLayerComponent } from './components/layers/address-layer.component';
import { PolygonLayerComponent } from './components/layers/polygon-layer-component';
import { PopupComponent } from './components/update-popup/popup.component';
import { SearchPopupComponent } from './components/search-popup/search-popup.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { PipesModule } from '../../src/app/modules/pipes/pipes.module';
import { GridModule } from '@progress/kendo-angular-grid';
import { SharedModule } from '../../src/app/modules/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { EventsLayerComponent } from './components/layers/events-layer.component';

@NgModule({
    declarations: [
        BenomadLayerComponent,
        DrawInteractionComponent,
        MapComponent,
        SelectInteractionComponent,
        StreetLayerComponent,
        EventsLayerComponent,
        DeviceLayerComponent,
        AddressLayerComponent,
        PolygonLayerComponent,
        PopupComponent,
        SearchPopupComponent
    ],
    imports: [CommonModule, ButtonsModule, SharedModule, GridModule, PipesModule, ReactiveFormsModule],
    providers: [
        InteractionService,
        LogService
    ],
    exports: [
        BenomadLayerComponent,
        DrawInteractionComponent,
        MapComponent,
        SelectInteractionComponent,
        StreetLayerComponent,
        EventsLayerComponent,
        DeviceLayerComponent,
        AddressLayerComponent,
        PopupComponent,
        SearchPopupComponent,
        PolygonLayerComponent
    ]
})
export class MapModule { }



// WEBPACK FOOTER //
// ./libs/map/map.module.ts